"use client";

import { c as _c } from "react/compiler-runtime";
import type { CartItemOutputDto } from "@sticker-giant/sg-frontend-common";
import { useState } from "react";
import ApplyButton from "@/components/custom/ProductBuilder/ApplyButton";
import { Input } from "@/components/ui/input";
import { trackCustomQuantityEntered } from "@/lib/analytics/segment";
import { getQuantityError, parseQuantityInput, stripQuantitySeparators } from "@/lib/product/customQuantityValidation";
import { useQuantitiesForItem } from "@/queries/useQuantitiesForItem";
interface Props {
  item: CartItemOutputDto;
  onApply: (quantity: number) => void;
  prefill: boolean;
}
export function CartCustomQuantity(t0) {
  const $ = _c(33);
  const {
    item,
    onApply,
    prefill
  } = t0;
  const {
    quantities,
    materialOption
  } = useQuantitiesForItem(item);
  const minQuantity = materialOption?.minQuantity ?? quantities?.minCustomQuantity ?? 0;
  const maxQuantity = materialOption?.maxQuantity ?? quantities?.maxCustomQuantity ?? 0;
  const increment = quantities?.customQuantityIncrement ?? 1;
  let t1;
  if ($[0] !== increment || $[1] !== maxQuantity || $[2] !== minQuantity) {
    t1 = {
      minQuantity,
      maxQuantity,
      increment
    };
    $[0] = increment;
    $[1] = maxQuantity;
    $[2] = minQuantity;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const constraints = t1;
  let t2;
  if ($[4] !== item.quantity || $[5] !== prefill) {
    t2 = prefill ? item.quantity.toString() : "";
    $[4] = item.quantity;
    $[5] = prefill;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const [localValue, setLocalValue] = useState(t2);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [error, setError] = useState();
  let t3;
  if ($[7] !== item.quantity) {
    t3 = item.quantity.toString();
    $[7] = item.quantity;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const isUnchangedFromCart = localValue === t3;
  const isApplied = hasSubmitted && !!localValue && isUnchangedFromCart;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = function handleChange(value) {
      setLocalValue(stripQuantitySeparators(value));
      setError(undefined);
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleChange = t4;
  let t5;
  if ($[10] !== constraints || $[11] !== localValue || $[12] !== onApply) {
    const validate = function validate() {
      const parsed = parseQuantityInput(localValue);
      if (parsed === undefined) {
        if (localValue.trim()) {
          setError("Please enter a valid quantity");
        }
        return;
      }
      const quantityError = getQuantityError(parsed, constraints);
      if (quantityError) {
        setError(quantityError);
        return;
      }
      onApply(parsed);
      setHasSubmitted(true);
      trackCustomQuantityEntered(parsed, "cart");
    };
    t5 = event => {
      event.preventDefault();
      validate();
    };
    $[10] = constraints;
    $[11] = localValue;
    $[12] = onApply;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = !!error || undefined;
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = event_0 => handleChange(event_0.target.value);
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== localValue || $[16] !== t6) {
    t8 = <Input inputMode="numeric" aria-invalid={t6} value={localValue} onChange={t7} className="max-w-24 text-sm" />;
    $[15] = localValue;
    $[16] = t6;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== isUnchangedFromCart || $[19] !== localValue) {
    t9 = !localValue.trim() || isUnchangedFromCart;
    $[18] = isUnchangedFromCart;
    $[19] = localValue;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== isApplied || $[22] !== t9) {
    t10 = <ApplyButton isApplied={isApplied} disabled={t9} />;
    $[21] = isApplied;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t8) {
    t11 = <div className="flex items-center gap-2">{t8}{t10}</div>;
    $[24] = t10;
    $[25] = t8;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== error) {
    t12 = error && <p role="alert" className="text-sm text-destructive">{error}</p>;
    $[27] = error;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t11 || $[30] !== t12 || $[31] !== t5) {
    t13 = <form onSubmit={t5} className="flex flex-col gap-2">{t11}{t12}</form>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t5;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
}